'use strict';

export default class CalendarAlgolia {
  constructor() {
    let $template_html;
    let $index_name = 'calendar';
    let $index_online = 'calendar_online';
    let $app_id = 'PV21YPDECK';
    let $app_key = '999fc9d3376250fbb4c0d870bb15e65c';
    let $page_size = 1000;
    let $search_result_hits;
    let calendar;
    let $color_map = false;
    let $containers = {
      pagingation: '.calendar-algolia-pagination',
      map: '.calendar-algolia-map',
      search_box: '.calendar-algolia-search-element',
      search_box_placeholder: 'Postcode, Suburb or town (Anything really)',
      search_result: '.calendar-algolia-result',
      facets: '.calendar-algolia-filters',
      search_container: '.search-box-elements',
    }
    let $configurations = {}
    let searchClient = algoliasearch($app_id, $app_key);

    $('body').on('click','.fc-event', function(e) {
      if(window.innerWidth < 768) {
        e.preventDefault();
      }
    });

    let options = {
      types: ['(regions)'],
      componentRestrictions: {
        country: "au"
      }
    };

    let customMapWidget = {
      _autocompleteContainer: document.querySelector('.calendar-algolia-places'),
      _mapContainer: document.querySelector('.calendar-algolia-map'),
      _hitToMarker: function (hit) {
        // console.log(hit)
        if (hit.lat) {
          return new google.maps.Marker({
            position: {
              lat: hit._geoloc.lat,
              lng: hit._geoloc.lng
            },
            map: this._map,
            title: hit.name
          });
        }
      },
      _handlePlaceChange: function (place) {
        // https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
        var place = this._autocomplete.getPlace();

        if (place.geometry === undefined) {
          // user did not select any place, see https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
          // events paragraph
          if (place.name === '') {
            // input was cleared
            this._helper
              .setQueryParameter('aroundLatLngViaIP')
              .search();
          }
          return;
        }

        // see https://developers.google.com/maps/documentation/javascript/reference#PlaceResult
        var latlng = place.geometry.location.toUrlValue();
        var field_online =
          // console.log(this._helper);
          // https://www.algolia.com/doc/guides/geo-search/geo-search-overview/#filter-and-sort-around-a-location
          this._helper
          .setQueryParameter('aroundLatLng', latlng)
          //.setFilters('aroundLatLng:'+latlng+' OR type:online') // @TODO
          .search();
      },
      init: function (params) {
        this._helper = params.helper;
        this._autocomplete = new google.maps.places.Autocomplete(this._autocompleteContainer, options);
        this._autocomplete.addListener('place_changed', this._handlePlaceChange.bind(this));
        this._map = new google.maps.Map(this._mapContainer, {
          zoom: 1,
          center: new google.maps.LatLng(0, 0)
        });

        // Restrict autocomplete to australia
        this._autocomplete.setComponentRestrictions({
          country: ["au"],
        });
      },
      render: function (params) {
        // console.log(params);
        var markers = params.results.hits.map(this._hitToMarker.bind(this));
        var bounds = new google.maps.LatLngBounds();
        markers.forEach(function (marker) {
          // console.log(marker);
          if (marker) {
            bounds.extend(marker.getPosition());
          }
        });
        this._map.fitBounds(bounds);

        // console.log(params);

        $search_result_hits = params.results.hits;
      }
    };

    // If we have a container then load
    if (haveSearchContainer()) {
      buildTemplates();
      loadColorMap();
      if (document.body.classList.contains('path-calendar')) {
        setTimeout(function () {
          loadAlgoliaSearch();
        }, 800)
      } else if (document.body.classList.contains('path-calendar-online')) {
        setTimeout(function () {
          loadAlgoliaOnlineSearch();
        }, 800)
      }

    }

    function loadAlgoliaSearch() {
      let $search = instantsearch({
        indexName: $index_name,
        searchClient,
        routing: {
          stateMapping: instantsearch.stateMappings.simple(),
        },
      });
      $search.addWidgets([

        instantsearch.widgets.configure({
          hitsPerPage: $page_size,
          // attributesToSnippet: ['body:30'],
          filters: '(NOT type:"Deadline Event")', 
          getRankingInfo: true,
          aroundLatLngViaIP: true,
          minimumAroundRadius: 1000, // 1km
          aroundRadius: 130000, // 60km
          typoTolerance: "min",
        }),

        // Pagination
        instantsearch.widgets.pagination({
          container: $containers.pagingation,
        }),

        // // Search box
        // instantsearch.widgets.searchBox({
        //     container: $containers.search_box,
        //     placeholder: $containers.search_box_placeholder,
        //     // showReset: true,
        //     autofocus: true,
        // }),

        // Facets
        instantsearch.widgets.refinementList({
          container: $containers.facets,
          attribute: 'type',
          sortBy: ['name:asc'],
          // showMore: true,
          // showMoreLimit: 200,
          // limit: 5,
          // showMore: true,
          templates: {
            item: `
                          <a href="{{url}}" class="ais-RefinementList-label {{#isRefined}}selected{{/isRefined}}" >
                            <span class="ais-RefinementList-labelText">{{label}} ({{count}})</span>
                          </a>
                        `,
          },
        }),


        // Search results
        instantsearch.widgets.hits({
          container: $containers.search_result,
          templates: {
            empty: $template_html.no_result,
            item: $template_html.search_item,
          },
          transformItems($items) {
            var $item_transformed_image_path = changeImageToThumbnail($items);
            return $item_transformed_image_path;
          }
        }),

        // instantsearch.widgets.geoSearch({
        //     container: $containers.map,
        //     googleReference: window.google,
        //     initialZoom: 2,
        //     enableRefine: true,
        // }),

        customMapWidget,
      ]);

      $search.start();

      $search.on('render', function ($hits) {
        // console.log('Algolia search complete loading calendar -- Follow from here to add calendar');
        loadCalendar();
      });
    }

    function loadAlgoliaOnlineSearch() {
      let $search = instantsearch({
        indexName: $index_online,
        searchClient,
        routing: {
          stateMapping: instantsearch.stateMappings.simple(),
        },
      });
      $search.addWidgets([

        instantsearch.widgets.configure({
          hitsPerPage: $page_size,
          //attributesToSnippet: ['body:30'],
          getRankingInfo: true,
          //filters:`field_is_online`,
        //   filters: '(NOT type:"Deadline Event")',
        //   facetFilters: ['field_is_online:true'],
        //   aroundLatLngViaIP: false,
        //   minimumAroundRadius: 1000, // 1km
        //   aroundRadius: 130000, // 60km
        //   typoTolerance: "min",
        }),

        // Pagination
        // instantsearch.widgets.pagination({
        //   container: $containers.pagingation,
        // }),

        // // Search box
        // instantsearch.widgets.searchBox({
        //     container: $containers.search_box,
        //     placeholder: $containers.search_box_placeholder,
        //     // showReset: true,
        //     autofocus: true,
        // }),

        // Facets
        instantsearch.widgets.refinementList({
          container: $containers.facets,
          attribute: 'type',
          sortBy: ['name:asc'],
          // showMore: true,
          // showMoreLimit: 200,
          // limit: 5,
          // showMore: true,
          templates: {
            item: `
                          <a href="{{url}}" class="ais-RefinementList-label {{#isRefined}}selected{{/isRefined}}" >
                            <span class="ais-RefinementList-labelText">{{label}} ({{count}})</span>
                          </a>
                        `,
          },
        }),


        // Search results
        instantsearch.widgets.hits({
          container: $containers.search_result,
          templates: {
            empty: $template_html.no_result,
            item: $template_html.search_item,
          },
          transformItems($items) {
            var $item_transformed_image_path = changeImageToThumbnail($items);
            return $item_transformed_image_path;
          }
        }),

        // instantsearch.widgets.geoSearch({
        //     container: $containers.map,
        //     googleReference: window.google,
        //     initialZoom: 2,
        //     enableRefine: true,
        // }),

        customMapWidget
      ]);

      $search.start();

      $search.on('render', function ($hits) {
        // console.log('Algolia search complete loading calendar -- Follow from here to add calendar');
        loadCalendar();
        hideSearchBox();
      });
    }

    function loadCalendar() {
      var calendarEl = document.getElementById('calendar_algolia_calendar');
      calendar = new FullCalendar.Calendar(calendarEl, {
        initialView: window.innerWidth >= 600 ? 'dayGridMonth' : 'listMonth',
        windowResize: function(view) {
            if (window.innerWidth >= 600 ) {
                calendarEl.getElementsByClassName('fc-dayGridMonth-button')[0].style.display = "block";
                calendar.changeView('dayGridMonth');
            } else {
                calendarEl.getElementsByClassName('fc-dayGridMonth-button')[0].style.display = "none";
                calendar.changeView('listMonth');
            }
        },
        headerToolbar: {
          left: 'prev,next',
          center: 'title',
          // right: 'dayGridMonth,dayGridWeek,timeGridDay,listMonth',
          right: 'dayGridMonth,dayGridWeek,listMonth'
        },
        views: {
          listMonth: {
            eventContent: function (event, element) {
              //return event;
            }
          }
        },
        eventContent: function (event, element) {
          //element.addClass(event.class)
          // console.log(element);
          // console.log(event.event._def.extendedProps.field_type);
          // console.log(event.event._def.extendedProps.field_type_id);
          var $color = getColor(event.event._def.extendedProps);
          return {
            // html: '<div class="fc-daygrid-event-dot ' + $color + '"></div><div class="fc-event-time ' + $color + '">' + event.timeText + 'm</div><div class="fc-event-title ' + $color + '">' + event.event._def.title + '</div><div class="popover"><div class="inner ' + $color + '"><div class="date"><h5>Date</h5><span class="day">' + event.event._def.extendedProps.field_smartdate_value + '</span><span class="month">' + event.event._def.extendedProps.field_smartdate_value_1 + '</span></div><div class="time"><h5>Duration</h5><span class="duration">' + event.event._def.extendedProps.field_smartdate_duration + ' minutes</span></div><div class="address"><h5>Address</h5>' + event.event._def.extendedProps.field_address + '</div><div class="description"><h5>Description</h5><p>' + event.event._def.extendedProps.field_short_description + '</p></div><div class="contact"><h5>Contact</h5>' + event.event._def.extendedProps.field_contact_details + '</div><div class="link button yellow">Find out more </div></div></div>'
            html: '<div class="fc-daygrid-event-dot ' + $color + '"></div><div class="fc-event-time ' + $color + '"></div><div class="fc-event-title ' + $color + '">' + event.event._def.title + '</div><div class="popover"><div class="inner ' + $color + '"><div class="date"><h5>Date</h5><span class="day">' + event.event._def.extendedProps.field_smartdate_value + '</span><span class="month">' + event.event._def.extendedProps.field_smartdate_value_1 + '</span></div><div class="time"><h5>Duration</h5><span class="duration">' + event.event._def.extendedProps.field_smartdate_duration + ' minutes</span></div><div class="address"><h5>Address</h5>' + event.event._def.extendedProps.field_address + '</div><div class="description"><h5>Description</h5><p>' + event.event._def.extendedProps.field_short_description + '</p></div><div class="contact"><h5>Contact</h5>' + event.event._def.extendedProps.field_contact_details + '</div><div class="link button yellow">Find out more </div></div></div>'
          };
        }

      });
      calendar.render();
      window.dispatchEvent(new Event('resize'));
      var currentDate = calendar.getDate(),
        parsedCurrentDate = Date.parse(currentDate),
        currentMonthHasNoEvent = true,
        targetDate = parsedCurrentDate;

      var date = new Date();
      var firstDayofCurrentMonth = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDayOfCurrentMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    //   console.log($search_result_hits);

      // Load the events
      $.each($search_result_hits, function ($index, $value) {
        //console.log('Loading:', $value.start);
        var currentDatetime = new Date($value.field_smartdate * 1000);
        let formattedDate = currentDatetime.getDate() + "/" + (currentDatetime.getMonth() + 1) + "/" + currentDatetime.getFullYear();
        var startValue = ($value.start) * 1000;

        if (startValue < lastDayOfCurrentMonth && startValue > firstDayofCurrentMonth) {
          currentMonthHasNoEvent = false;
          targetDate = parsedCurrentDate;
        }

        if (currentMonthHasNoEvent && startValue > lastDayOfCurrentMonth) {
          targetDate = startValue;
        }

        calendar.addEvent({
          title: $value.title,
          start: startValue,
          url: $value.url,
          extendedProps: {
            field_smartdate_value: $value.field_smartdate ? formattedDate : '',
            field_smartdate_value_1: $value.field_smartdate_1 ? $value.field_smartdate_1 : '',
            field_smartdate_duration: $value.duration ? $value.duration : '',
            field_address: $value.address_line1 + '<br/>' + $value.address_line2 + '<br/>' + $value.locality + ' ' + $value.postal_code,
            field_short_description: $value.field_short_description ? $value.field_short_description : '',
            field_contact_details: $value.field_contact_details ? $value.field_contact_details : '',
            field_contact_details: $value.field_contact_details ? $value.field_contact_details : '',
            field_type: $value.type ? $value.type : null,
          },
        });

      })


      // Pull in the National and Online events
      // addOnlineAndNational(calendar);

      calendar.getEvents();
      setTimeout(function () {
        calendar.gotoDate(targetDate);
      }, 1000);

    }

    function addOnlineAndNational($calendar) {
      $.getJSON("/api/events/nationalonline?_format=json")
        .done(function ($items) {
          $($items).each(function ($index, $value) {
            var currentDatetime = new Date($value.field_smartdate[0].end_value);
            let formattedDate = currentDatetime.getDate() + "/" + (currentDatetime.getMonth() + 1) + "/" + currentDatetime.getFullYear();
            $calendar.addEvent({
              title: $value.title[0].value,
              start: $value.field_smartdate[0].end_value,
              url: 'node/' + $value.nid[0].value,
              extendedProps: {
                field_smartdate_value: $value.field_smartdate ? formattedDate : '',
                field_smartdate_value_1: $value.field_smartdate_1 ? $value.field_smartdate_1 : '',
                field_smartdate_duration: $value.field_smartdate[0].duration ? $value.field_smartdate[0].duration : '',
                field_address: $($value.field_address).length ? $value.field_address[0].address_line1 + '<br/>' + $value.field_address[0].address_line2 + '<br/>' + $value.field_address[0].locality + ' ' + $value.field_address[0].postal_code : '',
                field_short_description: $($value.field_short_description).length ? $value.field_short_description[0].value : '',
                field_contact_details: $($value.field_contact_details).value ? $value.field_contact_details[0].value : '',
                field_type_id: $($value.field_type).length ? $value.field_type[0].target_id : null,
              },
            });
          })
        });
    }

    function changeImageToThumbnail($items) {

      $.each($items, function ($index, $item) {
        // console.log($item);
        if ($item['thumbnail']) {
          var $full_image_path = $item['thumbnail'];
          var $new_image_path = $full_image_path.replace("/sites/default/files/", "/sites/default/files/styles/thumbnail/public/");
          $items[$index]['thumbnail'] = $new_image_path;
        }

      })

      return $items;
    }

    function haveSearchContainer() {
      if (!$($containers.search_box).length) {
        return false;
      } else {
        return true;
      }
    }

    function buildTemplates() {

      var $item = "";
      $item += '<div class="item">';
      $item += '{{#icon}}<div class="icon"><img width="40" height="40" src="{{icon}}"></div>{{/icon}}';
      $item += '<div class="tag">{{#tags}}<span>{{tags}}</span>{{/tags}}<span>{{content_type}}</span></div>';
      $item += '{{#thumbnail}}<div class="thumbnail"><img width="280" height="168" src="{{thumbnail}}"></div>{{/thumbnail}}';
      $item += '<div class="title"><a href="{{ url }}"><h3>{{#helpers.highlight}}{"attribute": "title"}{{/helpers.highlight}}</h3></a></div>';
      // $item += '{{#description}}<div class="description">{{#helpers.highlight}}{"attribute": "description"}{{/helpers.highlight}}</div>{{/description}}';
      $item += '{{#body}}<div class="body">{{#helpers.snippet}}{"attribute": "body"}{{/helpers.snippet}}</div>{{/body}}';
      $item += '<a href="{{ url }}">Read more</a>';
      $item += '</div><br><br>';

      var $item = `
                <div class="item">
                    <ul>
                        <li class="icon {{type}}"><span>{{type}}</span></li>
                        <li class="name"><a href="{{url}}">{{title}}</a></li>
                        <li class="address">
                            <span class="add1">{{address_line1}}</span>
                            <span class="add2">{{address_line2}}</span>
                            <span class="locality">{{locality}}</span>
                            <span class="postal_code">{{postal_code}}</span>
                        </li>
                        <li class="contact">{{field_contact_details}}</li>
                        <li class="details">
                            <ul>
                            <li class="calendar {{#field_calendar}}enable {{/field_calendar}}"><a href="{{url}}#calendar">Calendar</a></li>
                            <li class="bp_hire {{#field_breastpump_hire}}enable {{/field_breastpump_hire}}"><a href="{{url}}#breastpump">Breastpump hire</a></li>
                            <li class="classes {{#field_classes}}enable {{/field_classes}}"><a href="{{url}}#classes">Classes</a></li>                            </ul>
                        </li>
                    </ul>
                </div>            
            
            `;


      var $search_result_stats = "";
      $search_result_stats += '<div class="searching-stats">';
      $search_result_stats += '<div class="label">Search results {{#query}}for \'{{query}}\'{{/query}}</div>';
      $search_result_stats += '<div class="result_count">{{nbHits}}</div>';
      $search_result_stats += '</div>';




      $template_html = {
        search_item: $item,
        no_result: '<div class="no-result">No match found</div>',
        index_item: '',
        stats: $search_result_stats,
      }
    }

    function loadColorMap() {
      $.getJSON("/api/terms/colors?_format=json")
        .done(function ($data) {
          $color_map = $data;
        });
    }

    function getColor($extended_data) {
      // console.log($extended_data);
      // console.log(event.event._def.extendedProps.field_type);
      // console.log(event.event._def.extendedProps.field_type_id);
      let $what_to_check = false;
      let $value_to_check;
      let $color = 'default-color';


      if ($extended_data.field_type) {
        $what_to_check = 'name';
        $value_to_check = $extended_data.field_type;
      }
      if ($extended_data.field_type_id) {
        $what_to_check = 'tid'
        $value_to_check = $extended_data.field_type_id;

      }

      if ($what_to_check) {
        // console.log('--- Checking: ', $value_to_check);
        $($color_map).each(function ($index, $value) {
          // console.log('----- Against: ', $value[$what_to_check]);
          if ($value[$what_to_check] == $value_to_check) {
            $color = $value['field_theme'];
          }
        })
      }

      return $color;
    }

    function hideSearchBox() {
      $('.calendar-algolia-search-element').css('display', 'none');
      $('.calendar-algolia-search-from p').text('Find Online Events and Workshops');
    }

  }
}
